// extracted by mini-css-extract-plugin
module.exports = {"container":"icon-module--container--EKlWK"};